import { CandidateStoryContent } from '../types';

export const validateStoryContent = (
  data: any,
): data is CandidateStoryContent[] => {
  if (!Array.isArray(data) || data.length === 0) {
    return false;
  }
  return data.every(
    item =>
      item &&
      typeof item === 'object' &&
      item.prompt &&
      typeof item.prompt.title === 'string' &&
      typeof item.response === 'string',
  );
};

export const isLegacyCandidateStoryContent = (content: string): boolean => {
  try {
    const parsed = JSON.parse(content);
    return !validateStoryContent(parsed);
  } catch {
    return true;
  }
};

export const parseStoryContent = (content: string): CandidateStoryContent[] =>
  JSON.parse(content);
